import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const BookingOptionSelectionsTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  {
    title: 'Name',
    align: 'start',
    key: 'selectionName',
    sortable: false,
    placeholder: 'Selection name',
  },
  { title: 'Product', align: 'start', key: 'productGUID', sortable: false, placeholder: 'Product' },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
